export default __webpack_public_path__ + "locales/bg/SMTPSettings.json?hash=a8e5a56f7374ab14885edf3f50ccc643";